/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Etaf_Link_Not_SentInputs */

const en_error_etaf_link_not_sent = /** @type {(inputs: Error_Etaf_Link_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email with the link could not be sent: try again later.`)
};

/**
* | output |
* | --- |
* | "The email with the link could not be sent: try again later." |
*
* @param {Error_Etaf_Link_Not_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_etaf_link_not_sent = /** @type {((inputs?: Error_Etaf_Link_Not_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Etaf_Link_Not_SentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_etaf_link_not_sent(inputs)
});